import { IKImage } from "imagekitio-react";
import React, { useEffect, useState } from "react";
import PriceTag from "./PriceTag";
import PriceButton from "./PriceButton";
import ReactPlayer from "react-player";
import ProductAnnualModal from "../ProductAnnualModal";
import { useSelector } from "react-redux";
import "../PlanInformation1.jsx/index.css";

const PlanInformation = ({
  activeCard,
  activeChildProduct,
  setActiveChildProduct,
  activeChildButton,
  setActiveChildButton,
  bookingProduct,
  razorpayHandler,
  setDowngradeModal,
  setIsCheckModal,
  proPlusData,
  setIsCareerGoal,
  mainRef,
  userToggle,
  setActiveOddUserPricingId,
  maxData,
  setDefaultSticky,
}) => {
  const [isModalEnabled, setIsModalEnabled] = useState(false);
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const isBlocked = useSelector(
    (store) => store?.userActivity?.user_trial_blocked,
  );
  const userPlan = useSelector((store) => store?.userSubscription);
  function getSelectedGoal() {
    if (activeCard?.plan_name === "LearnTube Pro") {
      setActiveOddUserPricingId(1);
      return { goal_name: "Certifications", product: "LearnTube Pro" };
    } else if (activeCard?.plan_name === "LearnTubeX") {
      setActiveOddUserPricingId(2);
      return { goal_name: "Practical Learning", product: "LearnTubeX" };
    } else {
      setActiveOddUserPricingId(3);
      return { goal_name: "Placements", product: "LearnTube Max" };
    }
  }

  return (
    <div
      className="mt-2 flex   w-full  flex-col items-center justify-center  rounded-lg md:mt-8 md:px-2"
      style={{
        background:
          !userToggle &&
          "linear-gradient(238.65deg, #13A0BD 16.15%, #086788 86.12%)",
      }}
    >
      <div className="flex w-full flex-col items-center  justify-center rounded-lg bg-white px-3 py-2 md:py-4">
        <div className="self-start text-lg font-medium">
          {activeCard?.plan_pointer_heading}
        </div>
        <div className="grid w-full self-start md:grid-cols-2">
          {activeCard?.plan_pointers?.map((point, idx) => (
            <div className="mt-1 flex w-full items-center text-sm md:mt-2">
              {point?.is_available ? (
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src="https://img.learntube.ai/public-assets/PRICING/img10.svg?updatedAt=1658938810160"
                  transformation={[
                    {
                      height: "150",
                      width: "150",
                    },
                  ]}
                  className="h-4 w-4 md:h-5 md:w-5"
                />
              ) : (
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src="https://img.learntube.ai/public-assets/PRICING/cross_18.svg?updatedAt=1681540173194"
                  transformation={[
                    {
                      height: "150",
                      width: "150",
                    },
                  ]}
                  className="h-4 w-4"
                />
              )}
              <div className="ml-2 md:text-[16px]">{point?.pointer_name}</div>
            </div>
          ))}
        </div>

        <PriceTag
          activePlanProducts={activeCard?.plan_products}
          activeChildProduct={activeChildProduct}
          setActiveChildProduct={setActiveChildProduct}
        />
        <PriceButton
          activePlanButtons={activeCard?.plan_button_states}
          activeChildButton={activeChildButton}
          setActiveChildButton={setActiveChildButton}
          activeChildProduct={activeChildProduct}
          activeCard={activeCard}
          bookingProduct={bookingProduct}
          razorpayHandler={razorpayHandler}
          setDowngradeModal={setDowngradeModal}
          setIsCheckModal={setIsCheckModal}
          maxData={maxData}
          setDefaultSticky={setDefaultSticky}
        />
        {activeCard?.plan_name != "Downgrade" && (
          <div
            className="mt-2 cursor-pointer text-sm font-medium text-pricing_blue underline "
            onClick={(e) => {
              setIsCareerGoal((prev) => ({
                ...prev,
                is_show: true,
                selected_goal: getSelectedGoal(),
              }));
              if (mainRef?.current) {
                mainRef?.current?.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            Need More Details? Explore Plan
          </div>
        )}
      </div>
      {activeCard?.is_active_plan ? (
        <div className="mt-2 w-full rounded-lg bg-[#DEFFEC] px-2 py-2 text-center text-xs text-[#59CF22] md:w-1/2 ">
          {activeCard?.plan_name} Plan is Active{" "}
          <span
            className="cursor-pointer text-pricing_blue underline "
            onClick={(e) => setIsModalEnabled(true)}
          >
            View Details
          </span>
        </div>
      ) : activeCard?.plan_name === "LearnTube Max" && user_role === 7 ? (
        <div className="mt-2 w-full rounded-lg bg-[#DEFFEC] px-2 py-2 text-center text-xs text-[#59CF22] md:w-1/2 ">
          LearnTube Max Trial Active,{" "}
          {(userPlan?.current_subscription_expires_at - Date.now()) /
            (1000 * 24 * 3600) >
          1
            ? `${Math.floor(
                (userPlan?.current_subscription_expires_at - Date.now()) /
                  (1000 * 24 * 3600),
              )} days`
            : `${Math.floor(
                (userPlan?.current_subscription_expires_at - Date.now()) /
                  (1000 * 3600),
              )} hrs`}{" "}
          Left.
          <span
            className="cursor-pointer text-pricing_blue underline "
            onClick={(e) => setIsModalEnabled(true)}
          >
            View Details
          </span>
        </div>
      ) : activeCard?.plan_name === "Downgrade" &&
        user_role === 1 &&
        !isBlocked ? (
        <div className="mt-2 w-full rounded-lg bg-[#DEFFEC] px-2 py-2 text-center text-xs text-[#59CF22] md:w-1/2 ">
          You're on Free Plan.
          <span
            className="cursor-pointer text-pricing_blue underline "
            onClick={(e) => setIsModalEnabled(true)}
          >
            View Details
          </span>
        </div>
      ) : (
        <></>
      )}
      {/* {activeCard?.plan_video?.length > 0 && userToggle && (
        <div className="mt-6 w-full md:mt-10">
          <div className="text-md mb-2 font-medium md:text-lg">
            Not Convinced Yet? Watch Plan Video
          </div>
          <ReactPlayer
            url={activeCard?.plan_video}
            config={{
              youtube: {
                playerVars: { modestbranding: 1, rel: 0 },
              },
            }}
            width={"100%"}
            height={
              window.innerWidth > 768
                ? window.innerWidth * (9 / 16) * (5 / 12)
                : window.innerWidth * (9 / 16)
            }
            controls={true}
            playing={false}
            onPlay={(e) => {
              // Mixpanel.track(Constants.Mixpanel.VIDEO_PLAYER_PLAY, {
              //     distinct_id: email
              // });
            }}
            onPause={(e) => {
              // Mixpanel.track(Constants.Mixpanel.VIDEO_PLAYER_PAUSE, {
              //     distinct_id: email
              // });
            }}
            //onError={(e)=> {console.log('videoPlayer' , e); dispatch(markVideoUnplayable(lessonId))}}
          />
        </div>
      )} */}
      {isModalEnabled && (
        <ProductAnnualModal
          activeCard={activeCard}
          isModalEnabled={isModalEnabled}
          setIsModalEnabled={setIsModalEnabled}
          proPlusData={proPlusData}
          bookingProduct={bookingProduct}
        />
      )}
    </div>
  );
};

export default PlanInformation;
